import { MediumTypesEnum } from 'src/modules/user-input/calcV100/constants.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { MediumParamsState } from 'src/modules/user-input/MediumParams/types.ts';
import { Unit } from 'uom';

export type MediumParamsAction = { type: 'medium_change'; payload: MediumTypesEnum }
| { type: 'concentration_change'; payload: string }
| { type: 'density_change'; payload: string }
| { type: 'density_unit'; payload: Unit.Unit<'Density'> }
| { type: 'specificHeatCapacity_change'; payload: string }
| { type: 'specificHeatCapacity_unit'; payload: Unit.Unit<'SpecificHeatCapacity'> }
| { type: 'temperature_change'; payload: number };

export const reducer = (prevState: MediumParamsState, action: MediumParamsAction): MediumParamsState => {
    const newState = { ...prevState };
    switch (action.type) {
        case 'medium_change': {
            newState.medium = action.payload;

            if (newState.medium !== MediumTypesEnum.Other) {
                newState.density = '';
                newState.heatCapacity = '';
            }
            break;
        }
        case 'temperature_change': {
            newState.temperature = action.payload;
            break;
        }
        case 'density_change': {
            newState.density = action.payload;
            break;
        }
        case 'density_unit': {
            newState.density = convert(
                newState.density,
                newState.densityUnit,
                action.payload,
            );
            newState.densityUnit = action.payload;
            break;
        }
        case 'specificHeatCapacity_unit': {
            newState.heatCapacity = convert(
                newState.heatCapacity,
                newState.heatCapacityUnit,
                action.payload,
            );
            newState.heatCapacityUnit = action.payload;
            break;
        }
        case 'specificHeatCapacity_change': {
            newState.heatCapacity = action.payload;
            break;
        }
        case 'concentration_change': {
            newState.concentration = action.payload;
            break;
        }
        default: {
            // no-op
        }
    }
    return newState;
};
